import {
  ADD_FILTER_SPACE_TYPE,
  ADD_FILTER_AMENITY,
  ADD_FLOOR_AREA_FILTER,
  REMOVE_FLOOR_AREA_FILTER,
  ADD_AVAILABILITY_FILTER,
  REMOVE_FILTER_SPACE_TYPE,
  REMOVE_FILTER_AMENITY,
  REMOVE_AVAILABILITY_FILTER,
  RECEIVE_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS,
  FAILED_RECEIVE_SEARCH_RESULTS,
  ADD_ORDERBY_METHOD,
  REMOVE_ORDERBY_METHOD,
  ADD_CITY_FILTER,
  REMOVE_CITY_FILTER,
  ADD_DISTRICT_FILTER,
  REMOVE_DISTRICT_FILTER,
  ADD_LOCATION_GROUP_FILTER,
  REMOVE_LOCATION_GROUP_FILTER,
  ADD_NEW_PROPERTY_FILTER,
  REMOVE_NEW_PROPERTY_FILTER,
  ADD_MOVEIN_FILTER,
  REMOVE_MOVEIN_FILTER,
  ADD_LOCATION_FILTER,
  REMOVE_LOCATION_FILTER,
  ADD_SEARCH_QUERY,
  REMOVE_SEARCH_QUERY,
  CHANGE_SEARCH_LOCATION
} from '../actions/search'

/**
 * Function returns the new search state based on the
 * given action.
 *
 * @param {object} state
 * @param {object} action
 */
const search = ( state = {}, action ) => {
  switch ( action.type ) {
    case ADD_FILTER_SPACE_TYPE:
      return {
        ...state,
        filters: {
          ...state.filters,
          space_type: action.data
        }
      }
    case ADD_FILTER_AMENITY: {
      let amenities = [ ...state.filters.amenities ]
      amenities.push( action.data )
      return {
        ...state,
        filters: {
          ...state.filters,
          amenities: amenities
        }
      }
    }
    case ADD_CITY_FILTER: {
      let cities = [ ...state.filters.cities ]
      if ( !cities.includes( action.data )) {
        cities.push( action.data )
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          cities: cities
        }
      }
    }
    case ADD_LOCATION_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          location: action.data
        }
      }
    }
    case REMOVE_LOCATION_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          location: ''
        }
      }
    }
    case ADD_SEARCH_QUERY: {
      return {
        ...state,
        query: action.data
      }
    }
    case REMOVE_SEARCH_QUERY: {
      return {
        ...state,
        query: ''
      }
    }
    case CHANGE_SEARCH_LOCATION: {
      return {
        ...state,
        query: action.data.type === 'custom' ? action.data.custom : '',
        didFetch: true,
        filters: {
          ...state.filters,
          location: action.data.type === 'location' ? action.data.location : '',
          cities: action.data.city ? [ action.data.city ] : [],
          districts: action.data.type === 'district' ? [ action.data.district ] : [],
        }
      }
    }
    case REMOVE_CITY_FILTER: {
      let cities = [ ...state.filters.cities ]
      let removeIndex = cities.indexOf( action.data )
      cities.splice( removeIndex, 1 )
      return {
        ...state,
        filters: {
          ...state.filters,
          cities: cities
        }
      }
    }
    case ADD_LOCATION_GROUP_FILTER: {
      let locationGroups = [ ...state.filters.locationGroups ]
      if ( !locationGroups.includes( action.data )) {
        locationGroups.push( action.data )
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          locationGroups: locationGroups
        }
      }
    }
    case REMOVE_LOCATION_GROUP_FILTER: {
      let locationGroups = [ ...state.filters.locationGroups ]
      let removeIndex = locationGroups.indexOf( action.data )
      locationGroups.splice( removeIndex, 1 )
      return {
        ...state,
        filters: {
          ...state.filters,
          locationGroups: locationGroups
        }
      }
    }
    case ADD_DISTRICT_FILTER: {
      let districts = [ ...state.filters.districts ]
      if ( !districts.includes( action.data )) {
        districts.push( action.data )
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          districts: districts
        }
      }
    }
    case REMOVE_DISTRICT_FILTER: {
      let districts = [ ...state.filters.districts ]
      let removeIndex = districts.indexOf( action.data )
      districts.splice( removeIndex, 1 )
      return {
        ...state,
        filters: {
          ...state.filters,
          districts: districts
        }
      }
    }
    case ADD_FLOOR_AREA_FILTER: {
      const min = ( action.data.min === null || action.data.min === undefined )
        ? state.filters.floor_area.min
        : action.data.min
      const max = ( action.data.max === null || action.data.max === undefined )
        ? state.filters.floor_area.max
        : action.data.max

      return {
        ...state,
        filters: {
          ...state.filters,
          floor_area: {
            min: min,
            max: max
          }
        }
      }
    }
    case REMOVE_FLOOR_AREA_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          floor_area: null
        }
      }
    }
    case ADD_AVAILABILITY_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          availability: true
        }
      }
    }
    case REMOVE_AVAILABILITY_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          availability: false
        }
      }
    }
    case REMOVE_FILTER_AMENITY: {
      let amenities = [ ...state.filters.amenities ]
      let removeIndex = amenities.indexOf( action.data )
      amenities.splice( removeIndex, 1 )
      return {
        ...state,
        filters: {
          ...state.filters,
          amenities: amenities
        }
      }
    }
    case REMOVE_FILTER_SPACE_TYPE:
      return {
        ...state,
        filters: {
          ...state.filters,
          space_type: ''
        }
      }
    case RECEIVE_SEARCH_RESULTS: {
      return {
        ...state,
        results: action.data.value,
        unfilteredResults: action.data.unfiltered,
        facets: {
          ...state.facets,
          districts: action.data['@search.facets']['neighborhood'],
          space_types: getSpaceTypes( action.data['unfiltered_facets']['spaces/type'], state ),
          floor_areas: action.data['@search.facets']['spaces/area'],
          cities: action.data['@search.facets']['city'],
          amenities: getAmenities( action.data['@search.facets']['building_services'], state )
        },
        isFetching: false,
        fetchPayload: {},
      }
    }
    case REQUEST_SEARCH_RESULTS: {
      return {
        ...state,
        isFetching: true,
        fetchPayload: action.data,
      }
    }
    case FAILED_RECEIVE_SEARCH_RESULTS: {
      return {
        ...state,
        isFetching: false,
        fetchPayload: {},
        error: action.data
      }
    }
    case ADD_ORDERBY_METHOD: {
      return {
        ...state,
        orderby: {
          ...state.orderby,
          field: action.data.field,
          order: action.data.order,
          title: action.data.title
        }
      }
    }
    case REMOVE_ORDERBY_METHOD: {
      return {
        ...state,
        orderby: {
          ...state.orderby,
          field: '',
          order: '',
          title: ''
        }
      }
    }
    case ADD_NEW_PROPERTY_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          new_property: true
        }
      }
    }
    case REMOVE_NEW_PROPERTY_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          new_property: false
        }
      }
    }
    case ADD_MOVEIN_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          movein: true
        }
      }
    }
    case REMOVE_MOVEIN_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          movein: false
        }
      }
    }
    default:
      return state
  }
}

/**
 * Function creates an array of amenities based on
 * the facets and given amenity names.
 *
 * @param {object} facets
 * @param {array} names
 * @return {array}
 */
const getAmenities = ( facets, state ) => {
  let amenities = []
  const initials = state.initial.facets.amenities
  initials.forEach(( initial ) => {
    facets.forEach(( facet ) => {
      if ( initial.value === facet.value ) {
        const amenity = {
          count: facet.count,
          value: facet.value,
          label: initial.label
        }
        amenities.push( amenity )
      }
    })
  })
  return amenities
}

/**
 * Function creates an array of space types based on
 * the facets and given space type names.
 *
 * @param {object} facets
 * @param {array} names
 * @return {array}
 */
const getSpaceTypes = ( facets, state ) => {
  let space_types = []
  const initials = state.initial.facets.space_types
  initials.forEach(( initial ) => {
    facets.forEach(( facet ) => {
      if ( initial.value === facet.value ) {
        const type = {
          count: facet.count,
          value: facet.value,
          label: initial.label,
          slug: initial.slug
        }
        space_types.push( type )
      }
    })
  })
  return space_types
}

export default search
